import {
  SiFacebook,
  SiInstagram,
  SiRoku,
} from "@icons-pack/react-simple-icons";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useTranslation } from "../hooks/useTranslation";

const Main = () => {
  const { t } = useTranslation();
  return (
    <div className="w-full h-[550px] text-white">
      <div className="w-full h-full">
        <div className="bg-black/60 absolute top-0 left-0 w-full h-[550px]"></div>
        <img
          className="w-full h-full object-cover"
          src={`./background.jpg`}
          alt="Banner Image"
        />
        <div className="absolute w-full top-[20%] p-4 md:p-8"></div>
        <div className="absolute w-full top-[20%] p-4 md:p-8">
          <h1 className="text-3xl md:text-5xl font-bold"> GCTV Canada </h1>
          {/*                 <div>
                    <button className='border bg-gray-300 text-black border-gray-300 py-2 px-5'>Play</button>
                    <button className='border text-white border-gray-300 py-2 px-5 ml-4'>Watch Later</button>
                </div> */}
          <p className="w-full md:max-w-[70%] lg:max-w-[50%] xl:max-w-[35%] text-gray-200">
            {t("heroDescription")} <a href="https://isilive.ca">iSiLIVE</a>
          </p>
          <a
            href="https://isilive.ca/contact/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex max-w-full items-center gap-3 rounded-full border border-white/30 bg-black/65 px-5 py-3 backdrop-blur-sm transition-all duration-200 hover:border-green-300/80 hover:bg-black/80 hover:shadow-lg"
          >
            <span
              className="h-2.5 w-2.5 rounded-full bg-green-400"
              aria-hidden="true"
            />
            <span className="text-sm md:text-base font-semibold text-white">
              {t("broadcastInterest")}
            </span>
          </a>
          <div className="pt-4 flex group">
            <a
              href="https://instagram.com/isilivecanada"
              target="_blank"
              rel="noreferrer"
            >
              <SiInstagram color="#FF0069" size={40} />
            </a>
            <a
              className="pl-4"
              href="https://www.facebook.com/isilivecanada"
              target="_blank"
              rel="noreferrer"
            >
              <SiFacebook color="#0866FF" size={40} />
            </a>
            <a
              className="pl-4"
              href="https://my.roku.com/account/add?channel=CQTLV6H"
              target="_blank"
              rel="noreferrer"
            >
              <SiRoku color="#662D91" size={40} />
            </a>
          </div>
          <button
            onClick={() =>
              document
                .getElementById("categories")
                ?.scrollIntoView({ behavior: "smooth" })
            }
            className="mt-6 inline-flex items-center gap-1 text-white/60 hover:text-white/90 text-sm transition-colors"
            aria-label="Scroll to categories"
          >
            Browse categories
            <MdKeyboardArrowDown size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Main;
